import "./jquery.lazyload";

//const img = require('../../../img/LN.svg');


const lazyLoadImage = () => {
    const elements = $(".lazyLoad");
    if (elements) {
        $(elements).lazyload({
            threshold: 400
            //placeholder: img
        });

        $(document).ready(() => {
            setTimeout(() => {
                $(".lazyLoad").trigger("scroll");
            }, 1000);
        });
    }
}

$(lazyLoadImage);

export function implementLazyLoadImage() {
    $(lazyLoadImage);
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/lazyload/lazyLoad.js